import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// Temporarily commented out while social icons are hidden
// import { Twitter, Linkedin, Instagram } from 'lucide-react';
// Still need Mail for the email display and X for the newsletter popup close button
import { Mail, X, CheckCircle, AlertCircle } from 'lucide-react';
import { subscribeToNewsletter } from '../lib/newsletterService';

const Footer: React.FC = () => {
  const [showNewsletter, setShowNewsletter] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [subscriptionResult, setSubscriptionResult] = useState<{ success: boolean; message: string } | null>(null);
  return (
    <footer className="relative bg-white text-black pt-8 pb-2">
      <div className="max-w-[2000px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Social Links - Temporarily hidden
          <div className="flex space-x-4">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" 
              className="hover:text-gray-600 transition-colors">
              <Twitter size={20} />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"
              className="hover:text-gray-600 transition-colors">
              <Linkedin size={20} />
            </a>
            <a href="https://artsy.net" target="_blank" rel="noopener noreferrer"
              className="hover:text-gray-600 transition-colors">
              <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" fill="none" 
                className="lucide lucide-artsy">
                <path d="M4 4h16v16H4z" />
                <path d="M12 4v16" />
                <path d="M4 12h16" />
              </svg>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"
              className="hover:text-gray-600 transition-colors">
              <Instagram size={20} />
            </a>
          </div>
          */}
          
          {/* Email and Newsletter - Kept visible */}
          <div className="flex flex-col space-y-2">
            <div className="flex items-center space-x-2 text-xs">
              <Mail size={14} />
              <span className="hover:text-gray-600 transition-colors">contact@substans.art</span>
            </div>
            <button 
              onClick={(e) => {
                e.preventDefault();
                setShowNewsletter(true);
              }}
              className="text-xs flex items-center hover:text-gray-600 transition-colors mt-1"
            >
              NEWSLETTER ›
            </button>
          </div>
        </div>

        <div className="mt-4 pt-3 border-t border-black/10 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
          <p className="text-xs text-black/60">&copy; {new Date().getFullYear()} substans. All rights reserved.</p>
          <div className="flex space-x-4">
            <Link to="/imprint" className="text-xs hover:text-gray-600 transition-colors px-1">IMPRINT</Link>
            <Link to="/privacy" className="text-xs hover:text-gray-600 transition-colors px-1">PRIVACY POLICY</Link>
          </div>
        </div>
        
        {/* Newsletter Popup */}
        {showNewsletter && (
          <div className="fixed inset-0 bg-gradient-to-br from-white via-blue-50 to-blue-200 flex items-center justify-center z-50 px-4 py-6">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full relative">
              <button 
                onClick={() => setShowNewsletter(false)}
                className="absolute top-4 right-4 text-gray-500 hover:text-black"
              >
                <X size={24} />
              </button>
              
              <div className="text-center mb-6">
                <h3 className="text-xl font-medium mb-2">Newsletter Sign Up</h3>
              </div>
              
              <form className="space-y-4" onSubmit={async (e) => {
                e.preventDefault();
                if (!email) return;
                
                setIsSubmitting(true);
                setSubscriptionResult(null);
                
                try {
                  const result = await subscribeToNewsletter(email);
                  setSubscriptionResult(result);
                  if (result.success) {
                    setEmail('');
                    // Auto-close the popup after successful subscription after 3 seconds
                    setTimeout(() => {
                      if (result.success) {
                        setShowNewsletter(false);
                        // Reset the subscription result after closing
                        setTimeout(() => setSubscriptionResult(null), 300);
                      }
                    }, 3000);
                  }
                } catch (error) {
                  console.error('Newsletter subscription error:', error);
                  setSubscriptionResult({
                    success: false,
                    message: 'An unexpected error occurred. Please try again later.'
                  });
                } finally {
                  setIsSubmitting(false);
                }
              }}>
                <input
                  type="email"
                  placeholder="Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-black"
                  required
                />
                
                {subscriptionResult && (
                  <div className={`text-sm flex items-center gap-2 p-2 rounded ${subscriptionResult.success ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                    {subscriptionResult.success ? (
                      <CheckCircle size={16} />
                    ) : (
                      <AlertCircle size={16} />
                    )}
                    <span>{subscriptionResult.message}</span>
                  </div>
                )}
                
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-white border border-black text-black py-2 rounded-md hover:bg-black hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'Signing Up...' : 'Sign Up'}
                </button>
                <p className="text-xs text-center text-gray-500 mt-2">
                  WHEN YOU SUBSCRIBE, YOU CONFIRM YOU HAVE READ SUBSTANS'S PRIVACY POLICY.
                </p>
              </form>
            </div>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;